import React from "react";
// react plugin for creating charts
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

import styles from "assets/jss/material-dashboard-react/components/chucnangStyle.js";
const useStyles = makeStyles(styles);
import Config from "conFig.js";

export default function Phuongtiengiaothong() {
  const classes = useStyles();
  const nam = new Date().getFullYear();
  const [phuongtien, setPhuongtien] = React.useState([]);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  const getptgiaothong = () => {
    var url =
      Config.backend + "/api/DashBoard/dashphuongtien?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setPhuongtien(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const renderTableHead = () => {
    return (
      <thead>
        <tr>
          <th className={classes.tabledb_th}>STT</th>
          <th className={classes.tabledb_th}>Chỉ tiêu/năm</th>
          <th className={classes.tabledb_th}>{nam - 1}</th>
          <th className={classes.tabledb_th}>{nam}</th>
        </tr>
      </thead>
    );
  };
  const renderTableBody = () => {
    return (
      <tbody>
        {phuongtien.map((row, i) => {
          return Number(row.tt) ? (
            <tr key={i}>
              <td className={classes.tabledb_td}>{row.tt}</td>
              <td className={classes.tabledb_td}>{row.chitieu}</td>
              <td className={classes.tabledb_td_number}>
                {Number(row.nam_truoc).toLocaleString()}
              </td>
              <td className={classes.tabledb_td_number}>
                {Number(row.nam_hientai).toLocaleString()}
              </td>
            </tr>
          ) : (
            <tr key={i}>
              <td className={classes.tabledb_td_ptgt}>{row.tt}</td>
              <td className={classes.tabledb_td_ptgt}>{row.chitieu}</td>
              <td className={classes.tabledb_td_number_ptgt}>
                {Number(row.nam_truoc).toLocaleString()}
              </td>
              <td className={classes.tabledb_td_number_ptgt}>
                {Number(row.nam_hientai).toLocaleString()}
              </td>
            </tr>
          );
        })}
      </tbody>
    );
  };
  var tHead = renderTableHead();
  var tBody = phuongtien.length > 0 ? renderTableBody() : null;
  React.useEffect(() => {
    getptgiaothong();
  }, []);
  return (
    <div className={classes.table} style={{ height: "210px" }}>
      <table className={classes.tabledb}>
        {tHead}
        {tBody}
      </table>
    </div>
  );
}
